/**
 * Written by Windsurf using model: Claude Sonnet 4.5 (Thinking)
 */
import { Grid, Typography, useTheme } from '@mui/material'

interface DepositModeSummaryProps {
  readonly totalPercentage: number
}

export default function DepositModeSummary({
  totalPercentage,
}: Readonly<DepositModeSummaryProps>) {
  const theme = useTheme()

  return (
    <Grid
      container
      sx={{
        py: 1,
        borderTop: '1px solid',
        borderColor: theme.palette.grey[200],
        backgroundColor: theme.palette.grey[50],
        justifyContent: 'flex-end',
      }}
    >
      <Grid
        size={{ md: 5 }}
        sx={{ px: 2, display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography
          variant="body2"
          fontWeight="medium"
          color={theme.palette.primary.main}
        >
          Total:
        </Typography>
        <Typography
          variant="body2"
          fontWeight="bold"
          color={totalPercentage === 100 ? 'success.main' : 'error.main'}
        >
          {totalPercentage}%
        </Typography>
      </Grid>
      <Grid size={{ md: 7 }}></Grid>
    </Grid>
  )
}
